import { useState, useEffect, useContext, useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Select from 'react-select';
import { Radio } from '@material-ui/core';
import { useSnackbar } from 'notistack';
// import SearchIcon from '@material-ui/icons/Search';
import SearchIcon from '@material-ui/icons/Search';
import * as api from '../../../services/api/admin';
import * as authApi from '../../../services/api/auth';
import { getSearchData } from '../../../services/api';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import { FilterSearchContext } from '../../../contexts/FilterContext';
function BookAppointmentFilter(props) {
  const {
    providerSearchFilter,
    classes: {
      form,
      h1,
      textInput,
      input,
      button,
      icon,
      container,
      customInput,
      customBtn,
      searchBoxWrapper,
      searchButtonIconColor = "#002952",
    },
  } = props;

  const { enqueueSnackbar } = useSnackbar();
  const [specialties, setSpecialties] = useState();
  const [cities, setCities] = useState([]);
  const [insurances, setInsurances] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCity, setSelectedCity] = useState([]);
  const [selectedInsurance, setSelectedInsurance] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState('');
  const [selectedSpecialty, setSelectedSpecialty] = useState([]);
  const [currentUser, setCurrentUser] = useState({});
  const [filterData, setFilterData] = useState([]);
  const [textInputValue, setTextInputValue] = useState('');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(null);
  const [address, setAddress] = useState('');
  const [previousAddress, setPreviousAddress] = useState('')
  const [coordinates, setCoordinates] = useState({})
  const [tenancyType, setTenancyType] = useState({ value: 'both' });
  const [selectedLocation, setSelectedLocation] = useState("");
  const [isEnter, setIsEnter] = useState(false);
  const [radioBtn, setRadioBtn] = useState('both')
  const [checkBox,setCheckBox] = useState({
    both: false,
    inPerson: true,
    telemedicine: false,
  })

  const { updateSearchBoxData, searchBoxData } = useContext(FilterSearchContext)
  const debounceTimeout = useRef(null);
  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        // getting user
        const user = await authApi.fetchCurrentUser();
        setCurrentUser(user);

        // geting specialties
        const fetchedSpecialties = await api.fetchSpecialties();
        // setSpecialties(fetchedSpecialties);

        // geting cities
        const fetchedCities = await api.fetchAllCities();
        setCities(fetchedCities);

        // geting insurances
        const fetchedInsurances = await api.fetchInsurances();
        setInsurances(fetchedInsurances);
      } catch (err) {
        enqueueSnackbar('Ooops, error fetching data, Please try again.');
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  // const onSearch = e => {
  //   e.preventDefault();
  //   setIsLoading(true);
  //   const bData = {
  //     city: selectedCity.id ? selectedCity.id : '',
  //     [specialties.type]: specialties.id ? specialties.id : '',
  //   };
  //   providerSearchFilter(bData);
  // };

  const getFilterData = async (value) => {
    const txtValue = value;
    const apiPayloadData = {
      searchInput: txtValue,
      city: selectedCity.value,
    };
    if (txtValue) {
      setLoading(true);
      debounceTimeout.current = setTimeout(async () => {
        try{
          const { data } = await getSearchData(apiPayloadData);
          setFilterData(data);
          setLoading(false);
        }
        catch(err){
          console.log("Error: ",err);
        }
      },750)
      
    } else {
      setFilterData([]);
    }
  };
  // const filterOptions = createFilterOptions({
  //   stringify: option => option.name + option.id,
  // });
  const selectStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? 'white' : 'black',
      fontWeight: 'bold',
      marginBottom:"10px",
    }),
    control: (styles) => ({
      ...styles,
      fontWeight: 'bold',
      fontSize: '1.1em',
      border: 'none',
      width: '100%',
      border: 0,
      boxShadow: 'none',
      backgroundColor: 'transparent',
    }),

    placeholder: (styles) => ({ ...styles, color: 'hsl(0, 0%, 35%)' }),
    singleValue: (provided) => ({
      ...provided,
      '& .provider-icon': {
        display: 'none !important',
      },
    }),
    menu: (styles) => ({
      ...styles,
      width: 'min-content',
      minWidth: '100%',
      marginBottom: '5px',
      left: '-2%',
      // minHeight:"10vh"
    }),
  };

  const providerOnSearch = (value) => {
    setLoading(null);
    setSelectedSpecialty(value);
    updateSearchBoxData({ specialty: value });

    // run the same logic as clicking the Search button
    OnSearch(value);
  };

  const OnSearch = (specialty = selectedSpecialty) => {
    setIsLoading(true);
    const bData = {
      city: selectedCity.id ? selectedCity.id : '',
      tenancyType: tenancyType?.value,
      selectedLocation: selectedLocation?.value,
      [specialty?.type]: specialty?.id,
      latitude: coordinates?.lat,
      longitude: coordinates?.lng,
      offSet: 0,
      limit: 10,
    };
    if(specialty.type === 'custom') bData.noResult = true
    providerSearchFilter(bData);
  };

  let searchOptions = {
    types: ['geocode'], // This allows broader location types
    componentRestrictions: { country: 'us' }, // Restrict to US
  };
  const handleSelect = async (address) => {
    setAddress(address);

    // this.search();
    // const { updateSearchBoxData, searchBoxData } = this.context;
    try {
      const results = await geocodeByAddress(address);
      const latLng = await getLatLng(results[0]);
      // this.setState({ coordinates: latLng });
      setCoordinates(latLng);
      setPreviousAddress(address);
      // this.setState({ previousAddress: address }); // Update previous valid address on successful selection
      await updateSearchBoxData({ address, coordinates: latLng });
      // this.search();
    } catch (error) {
      alert('Invalid Location..');
      console.error('Error', error);
    }
  };

  const handleFocus = () => {
    setAddress('');
    setCoordinates(null);
    // this.setState({ address: "", coordinates: null }); // Reset the address input field when it gains focus
  };

  const handleBlur = () => {
    //noting in specialities
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setIsEnter(true);
    }
  };

  const handleRadioBtn = async (event) => {
    let selectedTenancy = event.target.value;
    setRadioBtn(selectedTenancy);
    setTenancyType({ value: selectedTenancy });
  };

  return isLoading ? (
    <Grid container justifyContent="center" alignItems="center">
      <CircularProgress />
    </Grid>
  ) : (
    <div className="formWidth">
      <div className={form}>
        <h1 className={h1}>Find a Provider</h1>
        <Grid container spacing={2} className={container}>
          <Grid item xs={12} md={4}>
            <div className={searchBoxWrapper}>
              <SearchIcon />
              <Select
                fullWidth
                isSearchable
                isClearable={false}
                aria-label="Specialty/Name/Practice"
                placeholder="Search by Specialty, Provider Name, or Practice"
                components={{
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null,
                }}
                value={selectedSpecialty}
                onChange={providerOnSearch}
                onFocus={() => {
                  setLoading(null);
                  setSelectedSpecialty([]);
                }}
                onInputChange={(value) => {
                  setLoading(null);
                  getFilterData(value.trim(), selectedCity ? selectedCity : '');
                  setTextInputValue(value);
                }}
                options={[
                  ...filterData.map((data) => ({
                    value: data.name
                      ? data.name
                      : `${data.first_name} ${data.last_name}`,
                    label: data.name
                      ? data.name
                      : `${data.first_name} ${data.last_name}`,
                    id: data.id,
                    type: data.type,
                    imageUrl: data?.image_url || '',
                  })),
                  ...(textInputValue && !loading
                    ? [
                        {
                          value: `search:${textInputValue}`,
                          label: `Search "${textInputValue}"`,
                          id: null,
                          type: 'custom',
                        },
                      ]
                    : []),
                ]}
                noOptionsMessage={() => null} // hide default "No results found"
                styles={selectStyles}
                className={input}
              />
            </div>
          </Grid>

          {/* <Grid item xs={12} md={3}>
            <Select
              fullWidth
              isSearchable
              isClearable
              aria-label="City/Neighborhood"
              placeholder="City/Neighborhood"
              value={selectedCity}
              onChange={setSelectedCity}
              options={cities?.map(city => ({
                value: city.name,
                label: city.name,
                id: city.id,
              }))}
              styles={selectStyles}
              className={input}
            />
          </Grid> */}

          {/* <Grid item xs={12} md={3} lg={1}>
            <Button
              fullWidth
              color="secondary"
              variant="contained"
              aria-label="Submit"
              classes={{ root: button }}
              className={customBtn}
              onClick={onSearch}
            >
              <SearchIcon classes={{ root: icon }} />
            </Button>
          </Grid> */}
          <Grid item xs={12} md={3} lg={3}>
            <div className={searchBoxWrapper}>
              <PlacesAutocomplete
                value={address}
                onChange={(value) => {
                  // Allow only digits
                  if (/^\d*$/.test(value)) {
                    setAddress(value);
                  }
                  // setAddress(value)
                }}
                onSelect={handleSelect}
                styles={selectStyles}
                searchOptions={searchOptions}
              >


                {({
                  getInputProps,
                  suggestions,
                  getSuggestionItemProps,
                  loading
                }) => {
                  return (
                    <div style={{ width: '100%', height: '100%' }}>
                      <div style={{ width: '100%', height: '100%' }}>
                        <Select
                          aria-label="Select by location"
                          placeholder="Select by location"
                          value={selectedLocation}
                          onChange={async (e) => {
                            updateSearchBoxData({ selectedLocation: e });
                            setSelectedLocation(e);
                          }}
                          options={[
                            { value: 'all', label: 'All' },
                            { value: 'bronx', label: 'Bronx' },
                            { value: 'brooklyn', label: 'Brooklyn' },
                            { value: 'catskills region', label: 'Catskills Region' },
                            { value: 'manhattan', label: 'Manhattan' },
                            { value: 'new jersey', label: 'New Jersey' },
                            { value: 'staten island', label: 'Staten Island' },
                            { value: 'westchester', label: 'Westchester' },
                            { value: 'connecticut', label: 'Connecticut' },
                          ]}
                          styles={selectStyles}
                          className={input}
                        />
                        {/* <input
                          {...getInputProps({
                            placeholder: 'Search by zipcode',
                            className: 'location-search-input',
                            onFocus: handleFocus, // Call handleFocus when input field gains focus
                            onBlur: handleBlur, // Call handleBlur when input field loses focus
                            // ref: this.inputRef, // Assign ref to the input field
                            onKeyDown: handleKeyDown
                          })}
                        /> */}
                      </div>
                      {/* <div
                        className="autocomplete-dropdown-container"
                      // ref={this.dropdownRef}
                      >
                        {loading && <div className="option">Loading...</div>}
                        {suggestions
                        .filter(
                          (s) =>
                            s.types.includes("postal_code") ||
                            s.types.includes("neighborhood") ||
                            s.types.includes("sublocality") ||
                            s.types.includes("route")
                        )
                        .map((suggestion) => {
                          return (
                            <div
                              // style={{maxWidth:"40%"}}
                              {...getSuggestionItemProps(suggestion, {
                                className: 'option'
                              })}
                            >
                              <span>{suggestion.description}</span>
                            </div>
                          );
                        })}
                      </div> */}
                    </div>
                  );
                }}
              </PlacesAutocomplete>
            </div>
          </Grid>

          <Grid item xs={12} md={5} lg={4}>
            <div className={searchBoxWrapper} style={{
                justifyContent: "space-evenly",
                // flexFlow:'column',height:'100px',
                // alignItems: "flex-start",
                padding: "10px 0px",
              }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  // paddingBottom: "7px",
                }}
              >
                <Radio
                  size="small"
                  name="both"
                  value='both'
                  checked={radioBtn==='both'}
                  onChange={handleRadioBtn}
                  sx={{
                    padding: 0,
                    margin: 0,
                    '& .MuiSvgIcon-root': {
                      color: '#333333',
                    },
                    '&.Mui-checked .MuiSvgIcon-root': {
                      color: '#007bff',
                    },
                  }}
                />
                <p
                  style={{
                    color: "#333333",
                    fontSize: "16px",
                    fontWeight: "bold",
                    paddingLeft: "4px",
                  }}
                >
                  Both
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  // paddingBottom: "7px",
                }}
              >
                <Radio
                  style={{ padding: 0, margin: 0 }}
                  size="small"
                  name="inPerson"
                  value='inPerson'
                  checked={radioBtn==='inPerson'}
                  onChange={handleRadioBtn}
                  sx={{
                    padding: 0,
                    margin: 0,
                    '& .MuiSvgIcon-root': {
                      color: '#333333',
                    },
                    '&.Mui-checked .MuiSvgIcon-root': {
                      color: '#007bff',
                    },
                  }}
                />
                <p
                  style={{
                    color: "#333333",
                    fontSize: "16px",
                    fontWeight: "bold",
                    paddingLeft: "4px",
                  }}
                >
                  In person
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  // paddingBottom: "7px",
                }}
              >
                <Radio
                  style={{ padding: 0, margin: 0 }}
                  size="small"
                  name="telemedicine"
                  value='telemedicine'
                  checked={radioBtn==='telemedicine'}
                  onChange={handleRadioBtn}
                  sx={{
                    padding: 0,
                    margin: 0,
                    '& .MuiSvgIcon-root': {
                      color: '#333333',
                    },
                    '&.Mui-checked .MuiSvgIcon-root': {
                      color: '#007bff',
                    },
                  }}
                />
                <p
                  style={{
                    color: "#333333",
                    fontSize: "16px",
                    fontWeight: "bold",
                    paddingLeft: "4px",
                  }}
                >
                  Telemedicine
                </p>
              </div>
              {/* <Select
                aria-label="In-person or virtual visit"
                placeholder="In-person or virtual visit"
                value={tenancyType}
                onChange={(e) => {
                  updateSearchBoxData({ tenancyType: e });
                  setTenancyType(e)
                  // this.search();
                }}

                options={[
                  { value: "both", label: "Both" },
                  { value: "inPerson", label: "In Person" },
                  { value: "telemedicine", label: "telemedicine" },
                  // Add more options as needed
                ]}
                styles={selectStyles}
                className={input}
              /> */}
              {/* <div style={{ width: '100%', height: '100%' }}> */}
              {/* <input
                    aria-label="Tenency Type"
                    placeholder="Tenency Type"
                    value=""
                    styles={selectStyles}
                    className={'location-search-input'}
                  /> */}
              {/* <div
                    className="autocomplete-dropdown-container"
                    style={{margin: "10px"}}
                    ref={this.dropdownRef}
                  >
                    <div className="option">
                      <input type="radio" name="tanancyType" value="both" />
                      <span style={{marginLeft:"10px"}}>Both</span>
                    </div>
                    <div className="option">
                      <input type="radio" name="tanancyType" value='inPerson' />
                      <span>In Person</span>
                    </div>
                    <div className="option">
                      <input type="radio" name="tanancyType" value='telemedicine' />
                      <span>Telemedicine</span>
                    </div>
                    <div style={{ margin: "10px", display: "flex", justifyContent: "end" }}> 
                        <Button variant="contained" style={{ marginRight: "10px"}}>
                          Clear
                        </Button>
                        <Button variant="contained" >
                          Apply
                        </Button>
                    </div>

                  </div> */}
              {/* </div> */}
            </div>
          </Grid>

          <Grid item xs={3} md={1} lg={1}>
            <div className={searchBoxWrapper} style={{paddingLeft:"0px"}} onClick={OnSearch}>
              <div className="searchBtnBox">
                <SearchIcon
                  classes={{ root: icon }}
                  style={{ color: searchButtonIconColor }}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

const styles = theme => ({
  form: {
    width: '100%',
    // margin: '1.5em',
    // padding:"5px"
    padding:"1.5em"
  },
  h1: {
    marginBottom: '1em',
  },
  textInput: {
    width: '100%',
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    fontSize: '0.6em !important',
    transition: 'none',
    padding: '0.2em 0.4em 0.2em 1em ',
    margin: '0 0.75em 0 0.5em',
    border: '1px solid hsl(0,0%,80%)',
  },
  input: {
    fontSize: '13px',
    padding: '1px 4px 1px 6px',
    width: '100%',
  },
  button: {
    boxShadow: 'none',
    fontSize: '0.7em !important',
    display: 'flex',
  },
  icon: {
    fontSize: '2em !important',
  },
  container: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  customInput: {
    '& .MuiAutocomplete-input': {
      padding: '1px 4px 1px 6px !important',
    },
    '& .MuiFormControl-marginNormal': {
      margin: '0px !important',
    },
  },
  customBtn: {
    '& .MuiButton-label': {
      '& div': {
        display: 'flex',
      },
    },
  },
  searchBoxWrapper: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '20px',
    paddingLeft: '10px',
    height: '45px',
    border: '1px solid #bdbdbd',
    boxShadow:
      'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
    '&:hover': {
      boxShadow:
        'rgba(3, 102, 214, 0.3) 0px 3px 6px, rgba(3, 102, 214, 0.3) 0px 3px 6px',
    },
  },
});

export default withStyles(styles)(BookAppointmentFilter);
